<script>
import AppVariables from './AppVariables';
import Auth from './Auth';
import productsCompareService from '../services/api/ProductsCompareService';

const setIds = (ids = []) => localStorage.setItem('compared-products', JSON.stringify(ids));
const getIds = () => {
    const lsData = localStorage.getItem('compared-products');
    let productIds;

    if(lsData) {
        productIds = lsData ? JSON.parse(lsData): [];
    } else {
        productIds = [];
    }

    return productIds;
};

export default {
    mixins: [AppVariables, Auth],
    data() {
        return {
            comparedIconSizes: {
                width: 20,
                height: 20,
            }
        }
    },
    computed: {
        comparedProducts() {
            if(this.$store.state.compares.items && this.$store.state.compares.items.length) {
                return this.$store.state.compares.items;
            } else {
                return getIds();
            }
        },
        comparedCount() {
            return this.comparedProducts.length;
        },
        comparedIconPaths() {
            const path = this.getCdnPath() + '/icons/';

            return {
                isCompared: path + 'yellow-depressed-compare.svg',
                notCompared: path + 'yellow-pressed-compare.svg',
                comparedPageHeader: path + 'white-depressed-compare.svg',
                comparedPageDrawer: path + 'gray-depressed-compare.svg',
            }
        },
    },
    methods: {
        isCompared(productId) {
            return this.comparedProducts.includes(productId);
        },
        comparedIcon(productId) {
            return this.isCompared(productId) ? this.comparedIconPaths.isCompared : this.comparedIconPaths.notCompared;
        },
        getList() {
            if(!this.isUserLoggedIn && !getIds().length)
                return Promise.resolve([]);

            return productsCompareService.getList({ filters: { product_id: this.comparedProducts } })
                .then(res => {
                    const products = res.data.data;
                    const ids = products.map(product => product.id);
                    this.updateProductIdsInStorage(ids);

                    return products;
                })
                .catch(console.log)
        },
        setCompared() {
            this.$store.commit('setComparesIsUpdating', true);
            productsCompareService.getUserProductsIDs()
                .then(res => {
                    this.updateProductIdsInStorage(res.data);
                    this.$store.commit('setCompares', res.data);
                })
                .catch(err => console.log(err))
                .finally(() => {
                    this.$store.commit('setComparesIsUpdating', false);
                })
        },
        addToCompare(productId) {
            if (!this.isCompared(productId)) {
                if(this.isUserLoggedIn) {
                    productsCompareService.addToCompare({ productId })
                        .then(() => {
                            this.updateProductIdsInStorage([...this.comparedProducts, productId]);
                        })
                        .catch(console.log)
                } else {
                    this.updateProductIdsInStorage([...this.comparedProducts, productId]);
                }
            } else {
                this.$router.push('/products/compare');
            }
        },
        removeFromCompare(productId) {
            if(this.isUserLoggedIn) {
                return productsCompareService.removeFromCompare({ productId })
                    .then(res => {
                        const ids = this.comparedProducts.filter(id => id !== productId);
                        this.updateProductIdsInStorage(ids);

                        return res.data;
                    })
                    .catch(console.log)
            } else {
                const productIds = getIds().filter(item => item !== productId);
                setIds(productIds);
                this.$store.commit('setCompares', productIds);
                return Promise.resolve();
            }

        },
        updateProductIdsInStorage(ids) {
            setIds(ids);
            this.$store.commit('setCompares', ids);
        }
    }
}
</script>
